/* MD — Look grid: look overlay (fullscreen on mobile, centred dialog on desktop);
   picking a size adds straight to the bag via the store's cart toast. */
(function () {
  function init(root) {
    if (!root || root.dataset.mdlgBound) return;
    root.dataset.mdlgBound = '1';

    var COPY = {
      added: root.getAttribute('data-copy-added') || 'Added to bag',
      error: root.getAttribute('data-copy-error') || 'Try again',
      more: root.getAttribute('data-copy-more') || 'Read more',
      less: root.getAttribute('data-copy-less') || 'Read less'
    };
    var pool = root.querySelector('[data-mdlg-overlays]');
    var open = null;

    function lock() { document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; }
    function unlock() { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; }

    function close() {
      if (!open) return;
      open.hidden = true;
      open.classList.remove('mdlg-ov-host');
      pool.appendChild(open);
      open = null;
      unlock();
    }

    /* Only offer Read more when the copy actually overflows the clamp. */
    function syncMore(ov) {
      var desc = ov.querySelector('[data-mdlg-desc]');
      var btn = ov.querySelector('[data-mdlg-more]');
      if (!desc || !btn) return;
      desc.setAttribute('data-clamped', 'true');
      btn.setAttribute('aria-expanded', 'false');
      var t = btn.querySelector('[data-mdlg-more-text]');
      if (t) t.textContent = COPY.more;
      btn.hidden = desc.scrollHeight <= desc.clientHeight + 1;
    }

    function openIndex(i) {
      var ov = pool.querySelector('[data-mdlg-ov="' + i + '"]');
      if (!ov) return;
      close();
      document.body.appendChild(ov);
      ov.classList.add('mdlg-ov-host');
      ov.hidden = false;
      var sc = ov.querySelector('.mdlg__ovscroll');
      if (sc) sc.scrollTop = 0;
      open = ov;
      lock();
      requestAnimationFrame(function () { syncMore(ov); });
    }

    function add(id, row, control) {
      var flag = row ? row.querySelector('[data-mdlg-flag]') : null;
      if (control) control.disabled = true;
      if (flag) flag.textContent = COPY.added;
      var p = (window.MDCartToast && window.MDCartToast.add)
        ? window.MDCartToast.add(id, 1)
        : fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          }).then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
            .then(function (d) {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
              return d;
            });

      p.then(function () {
        if (row) row.setAttribute('data-added', '');
        if (control) control.disabled = false;
        setTimeout(function () { if (row) row.removeAttribute('data-added'); }, 2600);
      }).catch(function () {
        if (control) control.disabled = false;
        if (flag) { flag.textContent = COPY.error; if (row) row.setAttribute('data-added', ''); }
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mdlg-open]');
      if (t) openIndex(t.getAttribute('data-mdlg-open'));
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    document.addEventListener('change', function (e) {
      if (!open || !open.contains(e.target)) return;
      var sel = e.target.closest('[data-mdlg-select]');
      if (!sel || !sel.value) return;
      sel.setAttribute('data-chosen', '');
      add(sel.value, sel.closest('[data-mdlg-row]'), sel);
    });

    document.addEventListener('click', function (e) {
      if (!open) return;
      if (e.target === open) { close(); return; }
      if (!open.contains(e.target)) return;

      if (e.target.closest('[data-mdlg-close]')) { close(); return; }

      var more = e.target.closest('[data-mdlg-more]');
      if (more) {
        var desc = open.querySelector('[data-mdlg-desc]');
        var clamped = desc.getAttribute('data-clamped') === 'true';
        desc.setAttribute('data-clamped', clamped ? 'false' : 'true');
        more.setAttribute('aria-expanded', clamped ? 'true' : 'false');
        more.querySelector('[data-mdlg-more-text]').textContent = clamped ? COPY.less : COPY.more;
        return;
      }

      var one = e.target.closest('[data-mdlg-add]');
      if (one) add(one.getAttribute('data-mdlg-add'), one.closest('[data-mdlg-row]'), one);
    });

    window.addEventListener('resize', function () { if (open) syncMore(open); });
    document.addEventListener('shopify:section:unload', function () { close(); });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-mdlg]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
